import axios from "axios";
import api from "src/configs/api";
import {
  POST_CLONE_S3_FILE,
  GET_INSTANCES,
  GET_INSTANCE_DETAIL,
  CREATE_INSTANCE,
  EDIT_INSTANCE,
  DEPLOY_INSTANCE,
  GET_INSTANCE_UPLOAD_FILE_HISTORIES,
} from "src/constant/endpoint";

const getProjectInstances = async (params) => await api.get(GET_INSTANCES, { params }).then((response) => response?.data?.data);

const getProjectInstancesDetail = async (id) => await api.get(GET_INSTANCE_DETAIL(id)).then((response) => response?.data?.data);

const getProjectInstanceUploadFileHistories = async (id, params) =>
  await api.get(GET_INSTANCE_UPLOAD_FILE_HISTORIES(id), { params }).then((response) => response?.data?.data);

const createInstance = ({ data }) => api.post(CREATE_INSTANCE, { data }).then((response) => response?.data);

const deployInstance = ({ data }) => api.post(DEPLOY_INSTANCE, { data }).then((response) => response?.data);

const editInstance = ({ data, id }) => api.put(EDIT_INSTANCE(id), { data }).then((response) => response?.data);

const getContentFromLink = async (link) => axios.get(link);

const cloneS3File = async ({ data }) => await api.post(POST_CLONE_S3_FILE, { data }).then((response) => response?.data?.data);

export {
  createInstance,
  deployInstance,
  editInstance,
  getProjectInstances,
  getProjectInstanceUploadFileHistories,
  getProjectInstancesDetail,
  getContentFromLink,
  cloneS3File,
};
